import React from 'react'
import {Icon} from '@chakra-ui/react'

const VerticalDividerIcon = (props) => (
    <Icon viewBox="0 0 1 68" width="1" height="68" {...props}>
        <path d="M0.5 0V68" stroke="currentColor" />
    </Icon>
)

export default VerticalDividerIcon
